import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function Login() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await axios.post('/api/login', { username, password }, { withCredentials: true });
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('username', res.data.username);
            navigate('/');
        } catch (err) {
            setError(err.response?.data?.error || 'Σφάλμα σύνδεσης!');
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-card">
                <div className="auth-logo">
                    <img src="/static/img/logo.png" alt="S.I.M.E. Logo" />
                    <h2>S.I.M.E. Drawings</h2>
                    <p>Σύνδεση στο Portal</p>
                </div>

                {error && <div className="flash error">{error}</div>}

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Username</label>
                        <input type="text" value={username}
                            onChange={e => setUsername(e.target.value)}
                            placeholder="Το username σας" required />
                    </div>
                    <div className="form-group">
                        <label>Password</label>
                        <input type="password" value={password}
                            onChange={e => setPassword(e.target.value)}
                            placeholder="Ο κωδικός σας" required />
                    </div>
                    <button type="submit" className="auth-btn">Σύνδεση ➜</button>
                </form>

                <p className="auth-link">
                    Δεν έχετε λογαριασμό; <a href="/register">Εγγραφή 📝</a>
                </p>
                <p className="auth-link"><a href="/">← Επιστροφή στην αρχική</a></p>
            </div>
        </div>
    );
}

export default Login;
